import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from './CollectionsKt.mjs';
import { Collection1k04j3hzsbod0 as Collection } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../exceptions.mjs';
import { toList3jhuyej2anx2q as toList } from './_Collections.mjs';
import { asList2ho2pewtsfvv as asList } from './_ArraysJs.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function removeLastOrNull(_this__u8e3s4) {
  return _this__u8e3s4.s1() ? null : _this__u8e3s4.h5(get_lastIndex(_this__u8e3s4));
}
function addAll(_this__u8e3s4, elements) {
  if (isInterface(elements, Collection()))
    return _this__u8e3s4.z2(elements);
  else {
    var result = false;
    var _iterator__ex2g4s = elements.u1();
    while (_iterator__ex2g4s.v1()) {
      var item = _iterator__ex2g4s.w1();
      if (_this__u8e3s4.n2(item))
        result = true;
    }
    return result;
  }
}
function removeFirstOrNull(_this__u8e3s4) {
  return _this__u8e3s4.s1() ? null : _this__u8e3s4.h5(0);
}
function removeLast(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.s1()) {
    throw NoSuchElementException().f2('List is empty.');
  } else {
    tmp = _this__u8e3s4.h5(get_lastIndex(_this__u8e3s4));
  }
  return tmp;
}
function convertToListIfNotCollection(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection())) {
    tmp = _this__u8e3s4;
  } else {
    tmp = toList(_this__u8e3s4);
  }
  return tmp;
}
function addAll_0(_this__u8e3s4, elements) {
  return _this__u8e3s4.z2(asList(elements));
}
function removeAll(_this__u8e3s4, predicate) {
  return filterInPlace(_this__u8e3s4, predicate, true);
}
function filterInPlace(_this__u8e3s4, predicate, predicateResultToRemove) {
  var result = false;
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.u1();
  while ($this$with.v1())
    if (predicate($this$with.w1()) === predicateResultToRemove) {
      $this$with.u6();
      result = true;
    }
  return result;
}
//region block: exports
export {
  addAll_0 as addAll21mdhg523wnoa,
  addAll as addAll1k27qatfgp3k5,
  convertToListIfNotCollection as convertToListIfNotCollection2y7m25iq802o0,
  removeAll as removeAll3cm9rh0qak2y6,
  removeFirstOrNull as removeFirstOrNull15yg2tczrh8a7,
  removeLastOrNull as removeLastOrNull3odnlbetbttd4,
  removeLast as removeLast3759euu1xvfa3,
};
//endregion

//# sourceMappingURL=MutableCollections.mjs.map
